import { createFileRoute, redirect } from '@tanstack/react-router';
import { hasPermission } from '@/lib/permissions';

export const Route = createFileRoute('/_auth/_side-layout/settings')({
  beforeLoad: ({ context }) => {
    const to = hasPermission(context.userRole, { project: ['create'] })
      ? '/settings/projects'
      : '/settings/account';
    throw redirect({ to: to as string });
  },
});
